import { render } from "./ContactFormPerson.vue?vue&type=template&id=3f5ffb61"
import script from "./ContactFormPerson.vue?vue&type=script&lang=js"
export * from "./ContactFormPerson.vue?vue&type=script&lang=js"

import exportComponent from "/Users/user/Development/lauryncoleman/lauryncoleman/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__